export const envs = {
  appUrl: process.env.REACT_APP_APP_URL || 'http://localhost:3011',
  supabaseUrl: process.env.REACT_APP_SUPABASE_URL!,
  supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY!,
  BackendUrl: process.env.REACT_APP_BACKEND_URL!,
  // Legacy compat
  ImgCdnUrl: '',
  BackendBase: process.env.REACT_APP_SUPABASE_URL!,
};

export const theme = {
  iconSize: '1.4rem',
  maxWidth: 'max-w-lg',
  primaryColor: '#8AE7C5',
};
